/* eslint-disable max-len */
import modelData from '../modelData.json'

// THIS VERSION OF THE FUNCTION IS NOT USED - YOU ARE IN THE STANDALONE DIRECTORY

export const getBaseModels = (orgId) => async (dispatch) => {
  const modelIds = ['genericFormApi2', 'identification', 'invoices', 'receipts', 'ssn']
  const result = {}
  for (const model_id of modelIds) {
    const entry = modelData.models[model_id]
    if (entry && !entry.public?.isDeprecated) {
      result[model_id] = { public: entry.public }
    }
  }
  return result
}
